import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  removeEmptyParams(obj: Object): Object {
    for (const key in obj) {
      if (obj[key] == null || obj[key] === '') {
        delete obj[key];
      }
    }

    return obj;
  }
}
